import styles from './DateListed.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RefineRadio from '../RefineRadio/RefineRadio';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { optimisticUpdateDateListedClicked } from 'src/store/search/optimistic/refinement';

export default class DateListed extends Component {
  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    dateRanges: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, dateRanges } = this.props;

    return (
      <nav
        role="navigation"
        aria-labelledby="RefineDateListed"
        className={styles.root}
      >
        <ScreenReaderOnly>
          <h1 id="RefineDateListed">Date Listed</h1>
        </ScreenReaderOnly>
        <RefineRadio
          multiSelect={false}
          handleSelection={handleSelection}
          preNavigationAction={optimisticUpdateDateListedClicked}
          labelledBy="RefineDateListed"
          options={dateRanges}
          path="/jobs"
          data-automation="refineDateListed"
        />
      </nav>
    );
  }
}
